export default "__VITE_ASSET__DJi19Hmc__"